import React from 'react';
import { debounce } from 'lodash';
import { awardFusionPrize, getPrizeDetail } from 'lib/apis/nodeApi';
import { showCommonDialog } from 'lib/components/CommonDialog';
import { closeModal } from 'lib/components/Modal';
import { showCommonInputModal } from 'lib/components/CommonInputModal';
import { fetchReceiveLotteryPrize, getRedeemCode, receiveCashRequest } from 'lib/apis';
import { ATTA_REPORT } from 'lib/constants/atta';
import { DELIVER_STATUS, PrizeSource } from 'lib/constants/award';
import { report } from '../dataReport';
import toast from '../toast';
import { BenefitRecordAwardStatus } from 'lib/constants/fragment';
import { showCdkeyDialog } from 'lib/components/CdkeyDialog';
import './index.scss';

const prizeDetailCache = {};

async function receiveMarketingResourcePrize({ prizeId }) {
  let prizeDetail = prizeDetailCache[prizeId];

  if (!prizeDetail) {
    const res = await getPrizeDetail(prizeId);
    if (res?.code !== 0) {
      return;
    }
    prizeDetail = res.data;
    prizeDetailCache[prizeId] = res.data;
  }
  const { prizeName, receiveURL, marketingPrizeDescription } = prizeDetail || {};
  showCommonDialog({
    title: '- 如何领取 -',
    content: `恭喜您获得${prizeName}，${marketingPrizeDescription}`,
    confirmButtonText: receiveURL ? '前往使用' : '我知道啦',
    confirmCallback: () => {
      if (!receiveURL || !/^(http|https):\/\/[^ "]+$/.test(receiveURL)) {
        closeModal();
        return;
      }
      window.location.href = receiveURL;
    },
  });
}

async function handleCashReceive(params, callback) {
  const { lotteryId, qqUin, actId, prizeSource, fusionPrizeRecordId } = params;
  const res =
    prizeSource === PrizeSource.FRAGMENT_FUSION
      ? await awardFusionPrize({ fusionPrizeRecordId, lotteryId, qqUin })
      : await receiveCashRequest({ actId, lotteryId, qqUin });

  if (res?.code !== 0) {
    report(ATTA_REPORT.CASH.RECEIVE_FAIL_DIALOG_SHOW, {
      prizeSource,
    });
    showCommonDialog({
      title: '领取失败',
      content: '请稍后再试，若有疑问请咨询福利鹅微信公众号客服～',
    });
    return;
  }
  callback?.();
  report(ATTA_REPORT.CASH.RECEIVE_SUCCESS_DIALOG_SHOW, {
    prizeSource,
  });
  showCommonDialog({
    title: '领取成功',
    content: '到账以QQ钱包消息为准，若有疑问请咨询福利鹅微信公众号客服～',
    confirmButtonText: '我知道啦',
  });
}

async function receiveCash({ prizeInfo, callback, prizeSource }) {
  // 本期暂不开放微信领取
  // const globalStore = useGlobalStore.getState();
  // const accountType = getUserType();

  // if (accountType === LOGIN_TYPE.WX) {
  //   showReceiveCashDialog({
  //     prizePic: prizeInfo.prizePic,
  //     confirmCallback: () => {
  //       // todo 目前暂无微信领取方式
  //     },
  //   });
  //   return;
  // }
  report(ATTA_REPORT.CASH.QQ_DIALOG_SHOW, {
    prizeSource,
  });
  const validateFailedCallback = () => {
    report(ATTA_REPORT.CASH.QQ_VALIDATE_FAIL, {
      prizeSource,
    });
    toast.info('请输入正确的QQ号领取哦');
  };
  const commonParams = {
    placeholder: '请输入领取QQ号',
    maxLength: 12,
    minLength: 5,
  };

  // 二次确认弹窗
  const showConfirmDialog = (qqNumber) => {
    report(ATTA_REPORT.CASH.QQ_CONFIRM_DIALOG_SHOW, {
      prizeSource,
    });
    showCommonInputModal({
      title: '请确认领取QQ号',
      confirmButtonText: '确认',
      initialInputValue: qqNumber,
      confirmCallback: (confirmQQNumber) => {
        report(ATTA_REPORT.CASH.QQ_CONFIRM_DIALOG_CONFIRM, {
          prizeSource,
        });
        if (confirmQQNumber.length < commonParams.minLength) {
          validateFailedCallback();
          showConfirmDialog(confirmQQNumber);
          return;
        }
        handleCashReceive(
          {
            actId: prizeInfo.actId,
            lotteryId: prizeInfo.lotteryId,
            qqUin: confirmQQNumber,
            fusionPrizeRecordId: prizeInfo.fusionPrizeRecordId,
            prizeSource,
          },
          callback,
        );
      },
      bottomTips: '请确认QQ号为正常账户，否则发放失败不予补发哦~',
      ...commonParams,
    });
  };

  const showQQInputDialog = (initialInputValue = '') => {
    showCommonInputModal({
      initialInputValue,
      title: '如何领取',
      confirmButtonText: '确认领取',
      confirmCallback: (qqNumber) => {
        report(ATTA_REPORT.CASH.QQ_DIALOG_CONFIRM, {
          prizeSource,
        });
        if (qqNumber.length < commonParams.minLength) {
          validateFailedCallback();
          showQQInputDialog(qqNumber);
          return;
        }
        showConfirmDialog(qqNumber);
      },
      tips: '请确认领取QQ号为正常账户，否则发放失败不予补发哦~',
      bottomTips: '单用户仅能绑定1次领取QQ号',
      ...commonParams,
    });
  };
  showQQInputDialog();
}
const receiveCdkey = debounce(
  async (params: { prizeInfo; callback?; actId; lotteryId }) => {
    const { prizeInfo, callback, actId, lotteryId } = params;
    const { recordStatus, deliverStatus } = prizeInfo;
    const hasReceived =
      deliverStatus === DELIVER_STATUS.DELIVERED || recordStatus === BenefitRecordAwardStatus.Delivered;
    let redeemCode = prizeInfo.redeemCode;
    let redeemNo = prizeInfo.redeemNo;
    let redeemToken = prizeInfo.redeemToken;

    if (!hasReceived) {
      const res = await fetchReceiveLotteryPrize({ actId, lotteryId });
      if (res?.code !== 0) {
        showCommonDialog({
          title: '领取失败',
          content: '请稍后再试，若有疑问请咨询福利鹅微信公众号客服～',
        });
        return;
      }
      redeemToken = res?.data.prize_groups?.[0]?.prizes?.[0]?.redeem_token;
    }

    if (redeemToken) {
      const res = await getRedeemCode(redeemToken);
      if (res?.code !== 0) {
        showCommonDialog({
          title: '领取失败',
          content: '请刷新页面后重试，若有疑问请咨询福利鹅微信公众号客服～',
        });
        return;
      }
      callback?.();
      redeemCode = res.data.redeemCode;
      redeemNo = res.data.redeemNo;
    }

    showCdkeyDialog({ redeemCode, redeemNo, callback });
  },
  300,
  { leading: true, trailing: false },
);

export { receiveMarketingResourcePrize, receiveCash, receiveCdkey };
